import {ISetClipboardDataAction, IClearClipboardDataAction, SET_CLIPBOARD_DATA, CLEAR_CLIPBOARD_DATA} from './types/clipboard.types';
import {IElement} from '../../incase-domain/elements';

export const setClipboardDataAction = (data: IElement): ISetClipboardDataAction => ({
    type: SET_CLIPBOARD_DATA,
    payload: {data},
});

export const clearClipboardDataAction = (): IClearClipboardDataAction => ({
    type: CLEAR_CLIPBOARD_DATA,
});
